import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/Button";

export function LoginPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const reason = params.get("reason");
  const [starting, setStarting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(
    reason === "expired"
      ? "Tu sesión expiró. Inicia sesión de nuevo."
      : reason === "error"
        ? "No pudimos completar el inicio de sesión."
        : null,
  );

  useEffect(() => {
    if (auth.status === "authenticated") {
      void navigate("/", { replace: true });
      return;
    }
    if (auth.status === "unauthenticated" && !reason && !errorMessage) {
      void handleSignIn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.status]);

  const handleSignIn = async () => {
    setStarting(true);
    setErrorMessage(null);
    try {
      await auth.signIn("/");
    } catch {
      setErrorMessage("No pudimos iniciar el flujo de autenticación.");
      setStarting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <div className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-6 shadow-sm text-center">
        <h1 className="text-lg font-semibold text-slate-900">PahFacturar Admin</h1>
        {errorMessage ? (
          <div className="mt-4 flex items-start gap-2 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800 text-left">
            <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0" />
            <span>{errorMessage}</span>
          </div>
        ) : (
          <p className="mt-4 text-sm text-slate-500 flex items-center justify-center gap-2">
            <Loader2 className="h-4 w-4 animate-spin" />
            Redirigiendo al inicio de sesión…
          </p>
        )}
        {errorMessage && (
          <Button className="mt-4" size="md" onClick={handleSignIn} disabled={starting}>
            Reintentar
          </Button>
        )}
      </div>
    </div>
  );
}